import { Platform } from 'react-native';

export function scrollDocumentToTop() {
  if (Platform.OS !== 'web' || typeof window === 'undefined') {
    return;
  }
  window.scrollTo(0, 0);
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}
